export const styles = {
  text: {
    color: '#273754',
    marginBottom: '12px',
    fontSize: '16px',
    textAlign: 'center',
  },
}
